import styles from "../../../styles/ModelViewer/ProjectModelView.module.css";
import { Spin } from "antd";

export default function LoadingScreen({ progress, isLoaded }) {
    if (progress >= 100 || isLoaded) return null;

    return (
        <div className={styles.loading}>
            <div className={styles.spinner}></div>
            <Spin size="large" />
        </div>
    );
};